export default {"src":"/_next/static/media/clp_icon.cd43c61b.svg","height":53,"width":15,"blurWidth":0,"blurHeight":0};